import { createContext, useContext } from "react";

type AddEditContextType = {
  isTaskExist: boolean;
  taskList: any;
};

const AddEditTaskContext = createContext<AddEditContextType | null>(null);

export const useAddEditTaskContext = () => {
  const ctx = useContext(AddEditTaskContext);
  if (!ctx) {
    throw new Error(
      "useAddEditTaskContext must be used inside AddEditTaskProvider"
    );
  }
  return ctx;
};

export default AddEditTaskContext;
